import {
  textSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import AutosuggestField from 'platform/forms-system/src/js/fields/AutosuggestField';
import { getOrganizationOptions } from '../utils/organizations';

export const organizationNamePage = {
  uiSchema: {
    ...titleUI('Organization information'),
    burialInformation: {
      nameOfStateCemeteryOrTribalOrganization: {
        'ui:field': AutosuggestField,
        'ui:title': 'Search for a state or tribal cemetery',
        'ui:options': {
          getOptions: getOrganizationOptions,
          queryForResults: true,
          freeInput: true,
          debounceRate: 200,
        },
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      burialInformation: {
        type: 'object',
        required: ['nameOfStateCemeteryOrTribalOrganization'],
        properties: { nameOfStateCemeteryOrTribalOrganization: textSchema },
      },
    },
  },
};
